var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"invisible-controller-root"},[_c('button',{attrs:{"id":"closeWindowButton"},on:{"click":_vm.closeWindow}})])}
var staticRenderFns = []

export { render, staticRenderFns }